export function getShippingWeight(weightGrams) {
  if (weightGrams < 310) return weightGrams;
  // Extract the number of kilograms and remaining grams
  const kilograms = Math.floor(weightGrams / 1000);
  const remainingGrams = weightGrams % 1000;

  // Check if the remaining grams are 31 or more
  if (remainingGrams >= 310) {
    return (kilograms + 1) * 1000;
  }

  // If not, return the original weight rounded to the nearest kilogram
  return kilograms * 1000;
}
